import type React from "react"
import { useState } from "react"
import { Box, TextField, IconButton, CircularProgress } from "@mui/material"
import { Send, AttachFile } from "@mui/icons-material"

interface ChatInputProps {
  onSendMessage: (message: string) => Promise<void>
  disabled?: boolean
}

const ChatInput: React.FC<ChatInputProps> = ({ onSendMessage, disabled = false }) => {
  const [newMessage, setNewMessage] = useState("")
  const [sending, setSending] = useState(false)

  const handleSend = async () => {
    if (!newMessage.trim() || disabled || sending) return

    setSending(true)
    try {
      await onSendMessage(newMessage.trim())
      setNewMessage("")
    } finally {
      setSending(false)
    }
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", mt: "auto" }}>
      <IconButton color="primary" sx={{ mr: 1 }} disabled={disabled || sending}>
        <AttachFile />
      </IconButton>
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Escribe un mensaje..."
        value={newMessage}
        onChange={(e) => setNewMessage(e.target.value)}
        onKeyPress={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault()
            handleSend()
          }
        }}
        disabled={disabled || sending}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "24px",
          },
        }}
      />
      <IconButton
        color="success"
        onClick={handleSend}
        disabled={disabled || sending || !newMessage.trim()}
        sx={{ ml: 1 }}
      >
        {sending ? <CircularProgress size={24} color="inherit" /> : <Send />}
      </IconButton>
    </Box>
  )
}

export default ChatInput
